export const logBoxBaseZIndex = 1500;
